export enum NotificationImgType {
    alarm = 'alarm',
    deviceOverspeed = 'device-overspeed',
    geofenceEnter = 'in-geofence',
    geofenceExit = 'out-geofence',
}